import { createAction } from '@reduxjs/toolkit'

import { TagStatusItem } from 'types/GlobalWidgetTag'

// tryCreateWidgetTagStatus
export const create = createAction('create_widget_tag_status')
export const createSuccess = createAction<{
  statusItem: TagStatusItem
  tagId: string
  widgetId: string
}>('create_widget_tag_status_success')
export const createFailed = createAction('create_widget_tag_status_failed')

// tryUpdateWidgetTagStatus
export const update = createAction('update_widget_tag_status')
export const updateSuccess = createAction<{
  statusItem: TagStatusItem
  tagId: string
  widgetId: string
}>('update_widget_tag_status_success')
export const updateFailed = createAction('update_widget_tag_status_failed')

// tryDeleteWidgetTagStatus
export const destroy = createAction('delete_widget_tag_status')
export const destroySuccess = createAction<{
  id: string
  tagId: string
  widgetId: string
}>('delete_widget_tag_status_success')
export const destroyFailed = createAction('delete_widget_tag_status_failed')
